import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { FormattedTextInput3hltc3nesrzjq as FormattedTextInput } from './FormattedTextInput.commonHtml.mjs';
import { Companion_getInstance2v0f9t0g75gcs as Companion_getInstance } from '../../models/data.mjs';
import {
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KProperty02ce7r476m8633 as KProperty0,
  KProperty1ca4yb4wlo496 as KProperty1,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PhoneNumberFormat$USAClass;
function PhoneNumberFormat$USA() {
  if (PhoneNumberFormat$USAClass === VOID) {
    class $ extends PhoneNumberFormat() {
      static vda() {
        var $this = this.zda('USA', 0);
        PhoneNumberFormat_USA_instance = $this;
        return $this;
      }
      adb(clean) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'com.lightningkite.kiteui.views.direct.substringOrNull' call
          if (!(0 <= 0 ? 0 <= (charSequenceLength(clean) - 1 | 0) : false)) {
            tmp$ret$0 = null;
            break $l$block_0;
          }
          if (3 > charSequenceLength(clean)) {
            // Inline function 'kotlin.text.substring' call
            var endIndex = charSequenceLength(clean);
            tmp$ret$0 = toString(charSequenceSubSequence(clean, 0, endIndex));
            break $l$block_0;
          }
          // Inline function 'kotlin.text.substring' call
          tmp$ret$0 = toString(charSequenceSubSequence(clean, 0, 3));
        }
        var tmp0_safe_receiver = tmp$ret$0;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_0;
          if (!isBlank(tmp0_safe_receiver)) {
            tmp_0 = tmp0_safe_receiver;
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          return '';
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        var area = tmp_1;
        var tmp$ret$5;
        $l$block_2: {
          // Inline function 'com.lightningkite.kiteui.views.direct.substringOrNull' call
          if (!(0 <= 3 ? 3 <= (charSequenceLength(clean) - 1 | 0) : false)) {
            tmp$ret$5 = null;
            break $l$block_2;
          }
          if (6 > charSequenceLength(clean)) {
            // Inline function 'kotlin.text.substring' call
            var endIndex_0 = charSequenceLength(clean);
            tmp$ret$5 = toString(charSequenceSubSequence(clean, 3, endIndex_0));
            break $l$block_2;
          }
          // Inline function 'kotlin.text.substring' call
          tmp$ret$5 = toString(charSequenceSubSequence(clean, 3, 6));
        }
        var g1 = tmp$ret$5;
        var tmp$ret$8;
        $l$block_4: {
          // Inline function 'com.lightningkite.kiteui.views.direct.substringOrNull' call
          if (!(0 <= 6 ? 6 <= (charSequenceLength(clean) - 1 | 0) : false)) {
            tmp$ret$8 = null;
            break $l$block_4;
          }
          if (10 > charSequenceLength(clean)) {
            // Inline function 'kotlin.text.substring' call
            var endIndex_1 = charSequenceLength(clean);
            tmp$ret$8 = toString(charSequenceSubSequence(clean, 6, endIndex_1));
            break $l$block_4;
          }
          // Inline function 'kotlin.text.substring' call
          tmp$ret$8 = toString(charSequenceSubSequence(clean, 6, 10));
        }
        var g2 = tmp$ret$8;
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().d1();
        $l$block_6: {
          this_0.xb(_Char___init__impl__6a9atx(40));
          this_0.wb(area);
          if (area.length === 3) {
            this_0.wb(') ');
          }
          if (g1 == null) {
            break $l$block_6;
          }
          this_0.wb(g1);
          if (g1.length === 3) {
            this_0.xb(_Char___init__impl__6a9atx(45));
          }
          if (g2 == null) {
            break $l$block_6;
          }
          this_0.wb(g2);
        }
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'USA');
    PhoneNumberFormat$USAClass = $;
  }
  return PhoneNumberFormat$USAClass;
}
var PhoneNumberFormat_USA_instance;
var PhoneNumberFormat_entriesInitialized;
function PhoneNumberFormat_initEntries() {
  if (PhoneNumberFormat_entriesInitialized)
    return Unit_instance;
  PhoneNumberFormat_entriesInitialized = true;
  PhoneNumberFormat_USA_instance = PhoneNumberFormat$USA().vda();
}
var PhoneNumberFormatClass;
function PhoneNumberFormat() {
  if (PhoneNumberFormatClass === VOID) {
    class $ extends Enum() {
      static zda(name, ordinal) {
        var $this = this.c4(name, ordinal);
        $this.yda_1 = Regex().qh('(?:\\+\\d+ )?\\(\\d{3}\\) \\d{3}-\\d{4}|(?:\\+\\d+)?\\d{10}|(?:\\+\\d+-)?\\d{3}-\\d{3}-\\d{4}|(?:\\+\\d+ )?\\d{3} \\d{3} \\d{4}');
        return $this;
      }
      bdb(char) {
        return isDigit(char);
      }
    }
    initMetadataForClass($, 'PhoneNumberFormat');
    PhoneNumberFormatClass = $;
  }
  return PhoneNumberFormatClass;
}
function PhoneNumberFormat$isRawData$ref(p0) {
  var l = (_this__u8e3s4) => p0.bdb(_this__u8e3s4.z2_1);
  l.callableName = 'isRawData';
  return l;
}
function PhoneNumberFormat$format$ref(p0) {
  var l = (_this__u8e3s4) => p0.adb(_this__u8e3s4);
  l.callableName = 'format';
  return l;
}
function FormattedTextInput$_get_enabled_$ref_88xhgk(p0) {
  return () => p0.fbs();
}
function FormattedTextInput$_set_enabled_$ref_whse6o(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
function FormattedTextInput$_get_content_$ref_pok0f8(p0) {
  return () => p0.xbr_1;
}
function PhoneNumberInput$_get_content_$ref_seupzq() {
  return (p0) => p0.c2a();
}
function FormattedTextInput$_get_hint_$ref_iu6w22(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.FormattedTextInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.placeholder;
    var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function FormattedTextInput$_set_hint_$ref_61akla(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.FormattedTextInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    p0.vb5_1.bb4_1.kb7_1.placeholder = _this__u8e3s4;
    return Unit_instance;
  };
}
function PhoneNumberInput$_get_hint_$ref_rjq10() {
  return (p0) => p0.idb();
}
function PhoneNumberInput$_set_hint_$ref_dkg1hs() {
  return (p0, p1) => {
    p0.vcl(p1);
    return Unit_instance;
  };
}
function PhoneNumberInput$_get_hint_$ref_rjq10_0() {
  return (p0) => p0.idb();
}
function PhoneNumberInput$_set_hint_$ref_dkg1hs_0() {
  return (p0, p1) => {
    p0.vcl(p1);
    return Unit_instance;
  };
}
function FormattedTextInput$_get_align_$ref_vo3rx4(p0) {
  return () => p0.zbr_1;
}
function FormattedTextInput$_set_align_$ref_2d9bik(p0) {
  return (_this__u8e3s4) => {
    p0.dbs(_this__u8e3s4);
    return Unit_instance;
  };
}
var PhoneNumberInputClass;
function PhoneNumberInput() {
  if (PhoneNumberInputClass === VOID) {
    class $ {
      constructor(container) {
        var tmp = this;
        // Inline function 'com.lightningkite.kiteui.views.direct.formattedTextInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (FormattedTextInput())(container.pc());
        var tmp0_elvis_lhs = container.ebb_1;
        var p = tmp0_elvis_lhs == null ? container : tmp0_elvis_lhs;
        container.gbb(p, view);
        view.cbs(Companion_getInstance().yd5_1);
        var tmp_0 = PhoneNumberFormat$isRawData$ref(PhoneNumberFormat_USA_getInstance());
        view.bbs(tmp_0, PhoneNumberFormat$format$ref(PhoneNumberFormat_USA_getInstance()));
        container.hbb(p, view);
        tmp.cdb_1 = view;
        this.ddb_1 = PhoneNumberFormat_USA_getInstance();
        var tmp_1 = this;
        var tmp0 = this.cdb_1;
        var tmp_2 = KMutableProperty0();
        var tmp_3 = FormattedTextInput$_get_enabled_$ref_88xhgk(tmp0);
        tmp_1.edb_1 = getPropertyCallableRef('enabled', 0, tmp_2, tmp_3, FormattedTextInput$_set_enabled_$ref_whse6o(tmp0));
        var tmp_4 = this;
        var tmp_5 = KProperty0();
        tmp_4.fdb_1 = getPropertyCallableRef('content', 0, tmp_5, FormattedTextInput$_get_content_$ref_pok0f8(this.cdb_1), null);
        var tmp_6 = this;
        var tmp0_0 = this.cdb_1;
        var tmp_7 = KMutableProperty0();
        var tmp_8 = FormattedTextInput$_get_hint_$ref_iu6w22(tmp0_0);
        tmp_6.gdb_1 = getPropertyCallableRef('hint', 0, tmp_7, tmp_8, FormattedTextInput$_set_hint_$ref_61akla(tmp0_0));
        var tmp_9 = this;
        var tmp0_1 = this.cdb_1;
        var tmp_10 = KMutableProperty0();
        var tmp_11 = FormattedTextInput$_get_align_$ref_vo3rx4(tmp0_1);
        tmp_9.hdb_1 = getPropertyCallableRef('align', 0, tmp_10, tmp_11, FormattedTextInput$_set_align_$ref_2d9bik(tmp0_1));
      }
      ga2() {
        return this.cdb_1.ga2();
      }
      cba() {
        return this.cdb_1;
      }
      c2a() {
        var tmp0 = this.fdb_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('content', 1, tmp, PhoneNumberInput$_get_content_$ref_seupzq(), null);
        return tmp0.get();
      }
      vcl(_set____db54di) {
        var tmp0 = this.gdb_1;
        var tmp = KMutableProperty1();
        var tmp_0 = PhoneNumberInput$_get_hint_$ref_rjq10_0();
        // Inline function 'kotlin.setValue' call
        getPropertyCallableRef('hint', 1, tmp, tmp_0, PhoneNumberInput$_set_hint_$ref_dkg1hs_0());
        tmp0.set(_set____db54di);
        return Unit_instance;
      }
      idb() {
        var tmp0 = this.gdb_1;
        var tmp = KMutableProperty1();
        var tmp_0 = PhoneNumberInput$_get_hint_$ref_rjq10();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('hint', 1, tmp, tmp_0, PhoneNumberInput$_set_hint_$ref_dkg1hs());
        return tmp0.get();
      }
    }
    initMetadataForClass($, 'PhoneNumberInput', VOID, VOID, [CoroutineScope()]);
    PhoneNumberInputClass = $;
  }
  return PhoneNumberInputClass;
}
function PhoneNumberFormat_USA_getInstance() {
  PhoneNumberFormat_initEntries();
  return PhoneNumberFormat_USA_instance;
}
//region block: exports
export {
  PhoneNumberInput as PhoneNumberInput1tdzv8kpf7vme,
  PhoneNumberFormat_USA_getInstance as PhoneNumberFormat_USA_getInstance22618h2la6wkm,
};
//endregion

//# sourceMappingURL=PhoneNumberInput.mjs.map
